<template>
  <div class="loading">
    <div class="progress-icon-wrapper">
      <span v-if="loadingCaption">
        {{ loadingCaption }}
      </span>
      <div class="progress-icon"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  data() {
    return {};
  },
  props: {
    loadingCaption: String,
  },
};
</script>

<style scoped>
.loading {
  width: 100%;
  height: 100%;
  background-color: #ffff;
  position: relative;
}

.loading.transparent {
  background-color: #9191912e;
}

.progress-icon-wrapper {
  top: 0;
  bottom: 67px;
  height: fit-content;
  width: fit-content;
  left: 0;
  right: 0;
  margin: auto;
  position: absolute;
  z-index: 9999;
}

.progress-icon {
  width: 76px;
  height: 76px;
  margin-left: auto;
  top: 0;
  left: 0;
  margin-right: auto;
  margin-top: 28px;
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #313745;
  border-color: #313745 transparent #313745 transparent;
  animation: progress-icon 1.2s linear infinite;
}

.progress-icon-wrapper span {
  display: block;
  margin-top: 120px;
  font-size: 16px;
}
</style>
